export default {
  getCart: '/wdsx-shop/shopCart/getCart',
  saveCart: '/wdsx-shop/shopCart/saveCart',
  deleteCarts: '/wdsx-shop/shopCart/deleteCarts',
  updateCarts: '/wdsx-shop/shopCart/updateCart',
  selectCarts: '/wdsx-shop/shopCart/selectCart',
  getAddress: '/wdsx-shop/userAddress/getAddressListByUserId',
  saveAddress: '/wdsx-shop/userAddress/saveAddress',
  updateAddress: '/wdsx-shop/userAddress/updateAddress',
  generateOrder: '/wdsx-shop/order/generateOrder',
  getOrders: '/wdsx-shop/order/getUserOrderListPage',
  getOrderDetail: '/wdsx-shop/order/getOrderDetail',
  getSign: '/wdsx-shop/goods/shareGoodsCode',
  authentication: '/wdsx-shop/weixinUser/weixinLogin',
  getUserInfo: '/wdsx-shop/weixinUser/getWeixinUserInfo',
  getOrderByName: '/wdsx-shop/order/getOrderByGoodsNameAndIntroAndOrderSn',
  bindPhone: '/wdsx-shop/weixinUser/bingdingMobilePhone',
  deleteOrders: '/wdsx-shop/order/deleteOrder',
  saveEvaluate: '/wdsx-shop/productEvaluate/saveEvaluate',
  getCartNum: '/wdsx-shop/shopCart/getCartNum',
  payByJSSDK: '/wdsx-shop/payment/payByWeiXinJSAPI',
  changeOrderStatus: '/wdsx-shop/order/updateOrderStatus',
  getLogistics: '/wdsx-shop/shipping/getShopShippingByOrderSn',
  returnGoods: '/wdsx-shop/order/returnExchangeOrder',
  deleteAddress: '/wdsx-shop/userAddress/deleteAddressByIds',
  updateUserInfo: '/wdsx-shop/user/updateSelfInfo',
  settleIn: '/wdsx-shop/SupplierApply/create-no-token',
  getSettleRecord: '/wdsx-shop/SupplierApply/getSelfApplyRecord',
  applyDistributor: '/wdsx-shop/distributionApply/apply'
};
